import React, { ReactNode } from "react";
import classNames from "classnames";
import { ValidateStatus } from "@Configs/enum";
import "./FormItem.scss";
import CircleExclamation from "assets/icons/CircleExclamation";
import { Tooltip } from "antd";

export interface ValidateObject {
  validateStatus: ValidateStatus;
  message: string;
}

export interface FormItemProps {
  /**Show the status validation*/
  validateStatus?: ValidateStatus;
  /**The validated message*/
  message?: string;
  children: ReactNode;
  /**Place content to the right*/
  placeRight?: boolean;
  /**Pass object validated to display state of  children field*/
  validateObject?: ValidateObject;
  /**Pass true to only show error in tooltip */
  isTableCell?: boolean;
}

function FormItem(props: FormItemProps) {
  const {
    validateStatus,
    message,
    validateObject,
    children,
    placeRight = false,
    isTableCell = false,
  } = props;
  const { validateStatusValue, messageValue } = React.useMemo(() => {
    if (validateObject) {
      return {
        validateStatusValue: validateObject.validateStatus,
        messageValue: validateObject.message,
      };
    } else {
      return {
        validateStatusValue: validateStatus,
        messageValue: message,
      };
    }
  }, [message, validateObject, validateStatus]);

  return (
    <>
      <div
        className={classNames("form-item__container", {
          [`form-item__container--${validateStatusValue}`]: validateStatusValue,
        })}
      >
        {!isTableCell ? (
          <div
            className={classNames("form-item__content", {
              "justify-content-end": placeRight,
            })}
          >
            {children}
          </div>
        ) : (
          <Tooltip color="red" title={messageValue} >
            <div
              className={classNames("form-item__content", {
                "justify-content-end": placeRight,
                "form-item__content-error": messageValue
              })}
            >
              {children}
            </div>
          </Tooltip>
        )}
        {messageValue ? (
          <div className={classNames("form-item__message m-t--3xs", {
            "is-table-cell": isTableCell
          })}>
            <div className="icon_error">
              <CircleExclamation />
            </div>
            <div>
              <span>{messageValue}</span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}

export default FormItem;
